<button (click)="onClick()" class="circle {{color}}">
    <img src={{icon}} alt="">
</button>